import { useMechanicAuth } from '../MechanicAuthContext';
import { LogOut, Mail, Phone, Wrench, Building2 } from 'lucide-react';

export default function MechanicProfilePage() {
  const { user, logout, currentWorkspace } = useMechanicAuth();

  return (
    <div className="p-4 pb-20 space-y-4" data-testid="mechanic-profile">
      <h1 className="text-xl font-bold text-white">Profil</h1>

      <div className="bg-slate-900 border border-slate-800 rounded-xl p-5">
        <div className="flex items-center gap-4 mb-4">
          <div className="w-14 h-14 bg-amber-500/20 rounded-full flex items-center justify-center text-amber-400 font-bold text-lg">
            {user?.first_name?.[0]}{user?.last_name?.[0]}
          </div>
          <div>
            <p className="text-white font-semibold text-lg">{user?.first_name} {user?.last_name}</p>
            <div className="flex items-center gap-1 text-amber-400 text-xs">
              <Wrench size={12} />
              <span>Employe atelier</span>
            </div>
          </div>
        </div>
        <div className="space-y-3 border-t border-slate-800 pt-4">
          {currentWorkspace?.name && (
            <div className="flex items-center gap-3 text-sm" data-testid="profile-workspace">
              <Building2 size={16} className="text-slate-500" />
              <span className="text-slate-300">{currentWorkspace.name}</span>
            </div>
          )}
          <div className="flex items-center gap-3 text-sm">
            <Mail size={16} className="text-slate-500" />
            <span className="text-slate-300">{user?.email}</span>
          </div>
          {user?.phone && (
            <div className="flex items-center gap-3 text-sm">
              <Phone size={16} className="text-slate-500" />
              <span className="text-slate-300">{user?.phone}</span>
            </div>
          )}
        </div>
      </div>

      <button
        onClick={logout}
        className="w-full bg-red-500/10 border border-red-500/20 text-red-400 font-semibold py-3 rounded-xl flex items-center justify-center gap-2 text-sm active:bg-red-500/20"
        data-testid="logout-btn"
      >
        <LogOut size={18} /> Se deconnecter
      </button>
    </div>
  );
}
